import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Image, Translate, Button } from '@hydra/common/components';
import { sendEvent } from '@hydra/utils/gtm';

import keywordToolImg from '@hydra/assets/img/assistant/cms/assistant-keyword-tool.png';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: 'auto',
    margin: theme.spacing(4, 3),
    padding: theme.spacing(4, 3),
    borderRadius: theme.shape.borderRadius * 2.5,
    background: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  img: {
    marginBottom: theme.spacing(3),
    height: '150px',
    [theme.breakpoints.up('sm')]: {
      height: '270px'
    }
  },
  subheading: {
    padding: theme.spacing(0, 4)
  }
}));

export default function AddKeywordsUpgrade ({
  upgradeLink,
  upgradeDetails
}: {
  upgradeLink?: string | null,
  upgradeDetails?: { type: string, appId: string } | null
}) {
  const classes = useStyles();

  const sendEventOnClick = () => {
    sendEvent('keywordtool-upgrade-btn');
  };
  const onClick = (e: any) => {
    e.preventDefault();
    if (window && (window as any)._dAPI && (window as any)._dAPI.upgrade && upgradeDetails) {
      sendEventOnClick();
      (window as any)._dAPI.upgrade(upgradeDetails);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container justify='center'>
        <Grid container item xs={12} direction='column' justify='center' alignItems='center'>
          <Image src={keywordToolImg} className={classes.img} />
          <Typography variant='h2' align='center' gutterBottom component='h2'>
            <Translate content='serp_upgrade_title' />
          </Typography>
          <Typography align='center' paragraph className={classes.subheading}>
            <Translate content='serp_upgrade_subtitle' />
          </Typography>
          {
            upgradeDetails
              ? (
                <Button
                  size='medium'
                  variant='contained'
                  color='primary'
                  onClick={onClick}
                >
                  <Translate content='serp_upgrade_cta' />
                </Button>
                )
              : null
          }
          {
            upgradeLink
              ? (
                <Button
                  size='medium'
                  variant='contained'
                  color='primary'
                  target='_blank'
                  rel='nofollow noopener noreferrer'
                  href={upgradeLink}
                  onClick={sendEventOnClick}
                >
                  <Translate content='serp_upgrade_cta' />
                </Button>
                )
              : null
          }
        </Grid>
      </Grid>
    </div>
  );
}
